(()=>{
 function init(){
  const root=document.querySelector('[data-bm-adjustable-guide]');
  if(!root||root.dataset.ready)return;
  root.dataset.ready='true';
  let config=JSON.parse(root.querySelector('[data-base-config]').textContent);
  const familyMode=config.familyPage;
  const familySelect=root.querySelector('[data-base-family-model]');
  const familyData=root.querySelector('[data-base-family-config]');
  const familyModels=familyData?JSON.parse(familyData.textContent):[];
  let familyModel=familyModels[0];
  if(familyMode&&familyModel)config={...config,...familyModel};
  const cards=[...root.querySelectorAll('[data-base-value]')];
  const currency=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',maximumFractionDigits:2,minimumFractionDigits:0});
  const normalizeSize=value=>String(value||'').toLowerCase().replace(/\([^)]*\)/g,'').replace(/mattress(es)?/g,'').replace(/\s+/g,' ').trim();
  const priceOf=variant=>Math.max(0,Number(variant.price||0)-(config.promoEnabled?Number(variant.discount||0)*100:0));
  for(const card of cards){const retail=card.querySelector('[data-base-retail-config]');card.retailVariants=retail?JSON.parse(retail.textContent):[];}
  const productRoot=familyMode?root:document.querySelector('.product-box');
  const status=root.querySelector('[data-base-status]');
  if(!productRoot)return;
  function control(index){return productRoot.querySelector('select[data-product-option="option'+(index+1)+'"]');}
  function selectedOptions(){
   if(familyMode)return [familyModel.variants[0].options[0],'No Foundation (Mattress Only)'];
   const values=[];
   productRoot.querySelectorAll('select[data-product-option]').forEach(el=>{const m=el.dataset.productOption.match(/option(\d+)/);if(m)values[Number(m[1])-1]=el.value;});
   productRoot.querySelectorAll('input[data-product-option]:checked').forEach(el=>{const m=el.name.match(/option(\d+)/);if(m)values[Number(m[1])-1]=el.value;});
   return values;
  }
  function sync(){
   const selected=selectedOptions();
   for(const card of cards){
    const index=Number(card.dataset.optionIndex),value=card.dataset.baseValue;
    const match=config.variants.find(v=>v.available&&v.options[index]===value&&v.options.every((option,i)=>i===index||!selected[i]||option===selected[i]));
    const active=selected[index]===value;
    const button=card.querySelector('[data-base-choose]');
    card.classList.toggle('is-selected',active);
    button.disabled=!match;
    button.setAttribute('aria-pressed',String(active));
    button.textContent=!match?config.unavailable:active?config.selected:familyMode?config.familyChoose:config.choose;
    const priceBox=card.querySelector('[data-base-price]');
    const mattressOnly=config.variants.find(v=>v.options.every((option,i)=>i===index?/no foundation|mattress only|^none$/i.test(option):!selected[i]||option===selected[i]));
    priceBox.hidden=!match||!mattressOnly;
    if(match&&mattressOnly){
     const added=Math.max(0,priceOf(match)-priceOf(mattressOnly));
     card.querySelector('[data-base-added-price]').textContent='+'+currency.format(added/100);
     const size=selected.find((value,i)=>i!==index)||'';
     card.querySelector('[data-base-price-size]').textContent=size;
     const retail=card.retailVariants.find(v=>normalizeSize(v.options[0])===normalizeSize(size));
     const retailLine=card.querySelector('[data-base-retail]'),savingLine=card.querySelector('[data-base-saving]');
     if(retailLine&&savingLine){
      const saving=retail?Number(retail.price)-added:0;
      retailLine.hidden=saving<=0;savingLine.hidden=saving<=0;
      retailLine.textContent=saving>0?config.boughtSeparately.replace('__AMOUNT__',currency.format(retail.price/100)):'';
      savingLine.textContent=saving>0?config.bundleSaving.replace('__AMOUNT__',currency.format(saving/100)):'';
     }
    }
   }
  }
  root.addEventListener('click',event=>{
   const button=event.target.closest('[data-base-choose]');if(!button||button.disabled)return;
   const card=button.closest('[data-base-value]'),index=Number(card.dataset.optionIndex);
   if(familyMode){
    const selected=selectedOptions();
    const match=config.variants.find(v=>v.available&&v.options[index]===card.dataset.baseValue&&v.options.every((option,i)=>i===index||!selected[i]||option===selected[i]));
    if(match){const destination=new URL(familyModel.url,location.origin);destination.searchParams.set('variant',match.id);location.assign(destination.href);}
    return;
   }
   const select=control(index);
   if(select){select.value=card.dataset.baseValue;select.dispatchEvent(new Event('change',{bubbles:true}));select.focus({preventScroll:true});select.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'center'});}
   else {const radio=[...productRoot.querySelectorAll('input[name="option'+(index+1)+'"]')].find(el=>el.value===card.dataset.baseValue);if(radio)radio.click();}
   status.textContent=config.selector;
   sync();
  });
  const referenceDialog=root.querySelector('[data-base-reference-dialog]');
  let referenceTrigger;
  root.addEventListener('click',event=>{
   const link=event.target.closest('a[data-base-reference]');
   if(!link||!referenceDialog)return;
   const template=root.querySelector('[data-base-reference-content="'+link.dataset.baseReference+'"]');
   if(!template)return;
   event.preventDefault();
   referenceTrigger=link;
   referenceDialog.querySelector('[data-base-reference-title]').textContent=link.textContent.replace('↗','').trim();
   referenceDialog.querySelector('[data-base-reference-body]').replaceChildren(template.content.cloneNode(true));
   referenceDialog.showModal();
   referenceDialog.querySelector('[data-base-reference-close]').focus();
  });
  if(referenceDialog){
   referenceDialog.querySelector('[data-base-reference-close]').addEventListener('click',()=>referenceDialog.close());
   referenceDialog.addEventListener('click',event=>{const bounds=referenceDialog.getBoundingClientRect();if(event.target===referenceDialog&&(event.clientX<bounds.left||event.clientX>bounds.right||event.clientY<bounds.top||event.clientY>bounds.bottom))referenceDialog.close();});
   referenceDialog.addEventListener('close',()=>{if(referenceTrigger)referenceTrigger.focus({preventScroll:true});});
  }
  if(familySelect)familySelect.addEventListener('change',()=>{familyModel=familyModels.find(model=>model.handle===familySelect.value)||familyModels[0];config={...config,...familyModel};sync();});
  productRoot.addEventListener('change',()=>{sync();requestAnimationFrame(sync);});
  document.addEventListener('variant:change',sync);
  window.addEventListener('pageshow',sync);
  sync();
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
 document.addEventListener('shopify:section:load',init);
})();


